import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260804_add_labels_to_option_sets",
  description: "Add empty labels table to all option sets",
  apply(json: any, _warnings: string[], _errors: string[]): any {
    const optionSets = json.optionSets ?? {};
    for (const id of Object.keys(optionSets)) {
      if (!optionSets[id].labels) {
        optionSets[id].labels = {};
      }
    }
    return json;
  },
};

export default migration;
